import { Button } from "@/ui/button";
import { Modal } from "@/ui/modals";
import { useRef, useState } from "react";
import TpSlGroupComponent from "./tp-sl-group";
import { useBuySellBotTokenContext } from "../../providers/buy-sell-token-provider";
import { useOutsideClickHandler } from "@/hooks/use-outside-click-handler";
import { useBotUpdateAutoSellSettingMutation } from "@api/bot/bot-update-auto-sell-setting.ts";
import { useWallet } from "@providers/wallet";
import { useWeb3Auth } from "@web3auth/modal-react-hooks";
import {
  AutoSellSetting,
  BotAutoSellSettingResponse,
} from "@api/bot/bot-get-auto-sell-setting.ts";
import GradientBorderRadius from "@/ui/gradient-border-radius";

const TpSlProfileModalWithBtnV2 = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { tpSlValues, setTpSlValues } = useBuySellBotTokenContext();
  const modalRef = useRef<HTMLDivElement>(null);
  const { userId, appPubKey } = useWallet();
  const { isConnected } = useWeb3Auth();

  const { mutate } = useBotUpdateAutoSellSettingMutation();

  const handleDone = () => {
    const autoSellData = tpSlValues.map((val) => ({
      _id: val.id,
      value: Number(val.tpSl),
      sellPercent: Number(val.sellBalance),
    }));

    mutate(
      { appPubKey, userId, autoSellData },
      {
        onSuccess: (data: BotAutoSellSettingResponse) => {
          let mapped = [{ tpSl: "", sellBalance: "" }];

          if (data && data.autoSellSetting && data.autoSellSetting.length > 0) {
            mapped = data.autoSellSetting.map((item: AutoSellSetting) => ({
              id: item._id,
              tpSl: item.value.toString(),
              sellBalance: item.sellPercent.toString(),
            }));
          }

          setTpSlValues(mapped);
          setIsOpen(false);
        },
        onError: (err) => {
          console.error("Failed to update auto sell settings", err);
        },
      }
    );
  };

  useOutsideClickHandler(() => setIsOpen(false), [modalRef]);

  return (
    <>
      <GradientBorderRadius
        radius="bigger"
        gradient="default-border"
        hover="r-100"
      >
        <button
          onClick={() => {
            setIsOpen(!isOpen);
          }}
          disabled={!isConnected}
          className="w-full h-[1.875rem] text-center text-[0.75rem] font-semibold flex items-center justify-center"
        >
          Auto Sell Settings
        </button>
      </GradientBorderRadius>

      <Modal
        opened={isOpen}
        onClose={() => setIsOpen(false)}
        className="w-[28.125rem] min-h-[34.25rem] py-[0.9375rem] px-[0.6250rem] flex flex-col"
      >
        <div
          ref={modalRef}
          className="flex flex-col flex-1 overflow-hidden h-full"
        >
          <div className="flex-1 overflow-y-auto pr-1">
            <Modal.Title title="Auto sell" className="text-xs font-semibold" />
            <div className="w-full grid grid-cols-[13%,1fr,1fr] gap-[0.3215rem] pt-2 text-white">
              <TpSlGroupComponent
                value={tpSlValues}
                onChange={(v) => setTpSlValues(v)}
              />
            </div>
          </div>
          <Modal.Footer className="mt-auto pt-2 flex justify-end gap-2">
            <Button
              title="Done"
              active={false}
              className="w-[9.4375rem] font-semibold text-xs"
              onClick={handleDone}
            />
            <Button
              title="Clear"
              active={false}
              className="w-[9.4375rem] font-semibold text-xs"
              onClick={() => {
                setTpSlValues([]);
                setTpSlValues([{ tpSl: "", sellBalance: "" }]);
              }}
            />
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};

export default TpSlProfileModalWithBtnV2;
